import React, { useEffect, useRef, useState } from "react";
import "video.js/dist/video-js.css";
import useVideojsSamples from './useVideojsSamples';
import { Spinner } from "ui";
import { PLAYER_ID } from "config/constants";
import { useDRM } from "hooks";
import { Container, LoaderWrapper, PlayerWrapper } from "./styles";


const Player = ({
  uuid,
  hasDRM,
  src,
  onPlay,
  onEnd,
  onTimeUpdate,
  onDuration,
  playerRef,
  firstLoader: FirstLoader,
  children,
}) => {

  const [isFirstPlay, setIsFirstPlay] = useState(true);
  const [loader, setLoader] = useState(true);

  const CurrentLoader = FirstLoader
    ? () => <FirstLoader />
    : () => <Spinner size={48} />

  const {current: Loader} = useRef(() => <CurrentLoader />)

  const { processVideo } = useVideojsSamples();

  const { manifest, token } = useDRM(uuid, hasDRM)

  const handlePlay = () => {
    if (isFirstPlay) setIsFirstPlay(false)
    onPlay({ isFirstPlay })
  }

  const handleDuration = (e) => onDuration(e.target.duration)

  const handleTimeUpdate = (e) => onTimeUpdate(e.target.currentTime)

  const stopLoader = (e) => {
    // const { readyState } = e.target
    // const isReadyToPlay = readyState >= 3
    setLoader(false)
  }


  useEffect(() => {
    if (!hasDRM) return
    if (!manifest || !token) return

    processVideo(manifest, token)

    // eslint-disable-next-line
  }, [manifest, token]);


  useEffect(() => {
    if (src) return
    setLoader(true)
    setIsFirstPlay(true)
  }, [src])


  return (
    <Container>
      <PlayerWrapper>
        <div style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: '0',
          left: '0',
        }}>
          {/* {cast.isRunning && (
            <div style={{
              height: '100%',
              display: 'grid',
              placeItems: 'center'
            }}>
              <img src={thumbnail} alt='' />
            </div>
          )} */}

          <video
            id={PLAYER_ID}
            key={uuid}
            autoPlay
            onWaiting={() => setLoader(true)}
            playsInline
            onTimeUpdate={handleTimeUpdate}
            onCanPlay={stopLoader}
            onCanPlayThrough={stopLoader}
            onPlaying={stopLoader}
            onLoadedMetadata={stopLoader}
            onLoadedMetadataCapture={stopLoader}
            onPlay={handlePlay}
            onDurationChange={handleDuration}
            onEnded={onEnd}
            ref={playerRef}
            preload='metadata'
            src={src}
            type="video/mp4"
            // hidden={cast.isRunning}
            style={{
              height: '100%',
              width: '100%'
            }}
          >
            {children}
          </video>
        </div>
      </PlayerWrapper>

      {/* {loader && !cast.isRunning && ( */}
      {loader && (
        <LoaderWrapper>
          {isFirstPlay && FirstLoader
            ? <Loader />
            : <Spinner size={48} />
          }
        </LoaderWrapper>
      )}

    </Container>
  );
};

export default Player;
